import { NativePrice } from '@frontend/sports/odds/feature/native-price';

export interface Ambassador {
    image?: string;
    name?: string;
    singleAmbassadorTitle?: string;
}

export interface ThemedTab {
    name: string;
}

export interface OptionPrice {
    id: number;
    nativePrice: NativePrice;
}

export interface BetBuilderOption {
    id: number;
    optionPrice: OptionPrice;
    longId?: string;
    shortId?: string;
}

export interface BetBuilderMarket {
    id: number;
    name: string;
    nameSign: string;
    ambassador?: Ambassador;
    option: BetBuilderOption;
    themedTab?: ThemedTab;
    visibleOnBetBuilderTab?: boolean;
    longIds?: string[];
}

export class BetBuilderPrecreatedModel {
    fixtureId: string;
    hasMarkets: boolean;
    promotedMarkets?: BetBuilderMarket[];
    ambassadorsMarkets?: BetBuilderMarket[];
    themedTabMarkets?: BetBuilderMarket[];
}

export enum BetBuilderButtonSource {
    Coupons = 'coupons/betbuilder',
    Event = 'BetBuilder',
    TopEvents = 'TopEvents',
}

export enum BetBuilderBadgeType {
    BetBuilder = 'betbuilder',
    SGP = 'sgp',
}
